import { useTranslation } from 'react-i18next'
import { mediaUrl } from '../lib/sightingsApi'

interface Props {
  imageKeys: string[]
  alt: string
  /** Index shown in the wide-viewport side gallery (hover target). */
  previewIndex?: number
  onPreviewIndex?: (index: number) => void
  onOpenGallery?: (index: number) => void
}

export function ProfilePhotoStrip({
  imageKeys,
  alt,
  previewIndex,
  onPreviewIndex,
  onOpenGallery,
}: Props) {
  const { t } = useTranslation()

  if (imageKeys.length === 0) {
    return <p className="profile-photos-empty">{t('profile.noPhotos')}</p>
  }

  return (
    <div className="profile-photo-strip">
      {imageKeys.map((key, index) => (
        <button
          key={key}
          type="button"
          className={`profile-photo-thumb${
            previewIndex === index ? ' preview-active' : ''
          }`}
          onClick={() => onOpenGallery?.(index)}
          onMouseEnter={() => onPreviewIndex?.(index)}
          onFocus={() => onPreviewIndex?.(index)}
          aria-label={t('gallery.openPhoto', { number: index + 1 })}
        >
          <img src={mediaUrl(key)} alt={alt} />
        </button>
      ))}
    </div>
  )
}
